import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
/*import { LlScrollpaneService } from '../ll-scrollpane.service';*/
import { LlPermissionsService } from '../ll-permissions.service';
import { LlRolesService } from '../ll-roles.service';
import { LlModelsService } from '../ll-models.service';

@Component({
  selector: 'll-model-portfolio-switch',
  templateUrl: './ll-model-portfolio-switch.component.html',
  styleUrl: './ll-model-portfolio-switch.component.css'
})
export class LlModelPortfolioSwitchComponent {

  @ViewChild('mainDiv_model_portfolio_switch') mainDiv: ElementRef;

  constructor(
    private LlRolesService: LlRolesService,
    private LlPermissionsService: LlPermissionsService,
    private LlModelsService: LlModelsService,
  ) { }

  bundle = {
    showHorzTabs: false,
    showRemaining: false,
    function: '',
    parentW: 0,
    parentH: 0,
    remainingX: 0,
    remainingY: 40,
    remainingW: 0,
    remainingH: 0,
    showTab: true,
    hTabIndx: 0,
    horzTabs: [],
    activeHorzTab: ''
  }

  ngOnInit() { }

  ngOnDestroy() { }

  ngAfterViewInit() {
    this.setVars();
  }

  setVars() {
    this.bundle.showHorzTabs = false;
    this.bundle.showRemaining = false;

    this.bundle.function = this.mainDiv.nativeElement.parentElement.id;

    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;

    setTimeout(() => {
      this.bundle.remainingW = this.bundle.parentW;
      this.bundle.remainingH = this.bundle.parentH - this.bundle.remainingY;

      //console.log("this.bundle.remainingW:" + this.bundle.remainingW)
      //console.log("this.bundle.remainingH:" + this.bundle.remainingH)

      this.getData()
    });
  }

  getData() {

    let SYSTEMROLEID = this.LlRolesService.getActiveContactRoleId();

    this.bundle.horzTabs.splice(0);
    this.bundle.horzTabs.push({ lbl: "Most Recent BBCs" });
    this.bundle.horzTabs.push({ lbl: "Class-Availability" });
    this.bundle.horzTabs.push({ lbl: "Class-Liquidity Pct" });
    this.bundle.horzTabs.push({ lbl: "Class-AR Mix" });
    

    this.bundle.activeHorzTab = this.bundle.horzTabs[0].lbl;

    this.bundle.showHorzTabs = true;
    this.bundle.showRemaining = true;

  }

  selectTab(label) {
    this.bundle.activeHorzTab = label;
  }
}
